<h2 mat-dialog-title>{{ 'CALLS.ADMIN.BOARD_PACK.DIALOG_TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'CALLS.ADMIN.BOARD_PACK.DIALOG_DESCRIPTION' | translate }}</p>
  <app-file-upload [acceptedFileTypes]="['pdf']" [maxSize]="50_000_000" type="board-pack" (fileChange)="onFileChange($event)"></app-file-upload>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="isSubmitDisabled">
    {{ 'CALLS.ADMIN.BOARD_PACK.SUBMIT' | translate }}
  </button>
</mat-dialog-actions>
